import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Fuel, PlayCircle } from 'lucide-react';
import ServiceCard from '../components/ServiceCard';
import SEO from '../components/SEO';
import SchemaMarkup from '../components/SchemaMarkup';
// Debug components removed for production

export default function Home() {
  const navigate = useNavigate();

  const valuationService = {
    title: "What's My Property Worth?",
    description: "Get an accurate, data-driven valuation for your gas station property using our advanced Valuation Wizard. Our tool considers market data, industry metrics, and local factors to provide you with a comprehensive property assessment.",
    icon: <Fuel className="w-16 h-16" />,
    path: '/valuation'
  };

  return (
    <>
      <SEO
        title="Professional Gas Station Valuation Services"
        description="Get accurate, data-driven gas station market value estimates using our proprietary TAM methodology. Professional valuation reports trusted by station owners, brokers, and lenders nationwide."
        keywords="gas station valuation, gas station market value, convenience store valuation, fuel station worth, gas station business value"
      />
      <SchemaMarkup type="LocalBusiness" />
      <SchemaMarkup type="Service" />
      <div className="w-full">
        {/* Hero Section */}
      <div className="relative text-white">        
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://app.thefuelcentral.com/storage/v1/object/public/Stock%20Photos/banner-gas-station.jpg" 
            alt="Gas station with cars" 
            className="w-full h-full object-cover object-center"
          />
          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/70 to-blue-800/60"></div>
        </div>
        <div className="container mx-auto px-4 py-24 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">Discover Your Gas Station's True Value</h1>
            <p className="text-xl mb-8 text-blue-100">The first automated valuation model purpose-built for fuel retail. Currently serving Orange, Riverside, and San Bernardino Counties.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/valuation')}
                className="bg-fc-orange-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-fc-orange-600 transition-colors text-lg"
              >
                Discover Your Gas Station's True Value
              </button>
              <button
                onClick={() => navigate('/valuation-demo')}
                className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors text-lg flex items-center justify-center"
              >
                <PlayCircle className="w-5 h-5 mr-2" /> See How It Works
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Valuation Card Section */}
      <div className="container mx-auto px-4 -mt-16 relative z-10">
        <div className="max-w-xl mx-auto">
          <ServiceCard
            title={valuationService.title}
            description={valuationService.description}
            icon={valuationService.icon}
            onClick={() => navigate(valuationService.path)}
          />
        </div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold text-center mb-12">Why Choose Our Valuation Wizard?</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <h3 className="font-semibold mb-2">Data-Driven Analysis</h3>
              <p className="text-gray-600">Comprehensive market data and industry metrics for accurate valuations</p>
            </div>
            <div className="text-center">
              <h3 className="font-semibold mb-2">Expert Methodology</h3>
              <p className="text-gray-600">Industry-standard valuation methods trusted by professionals</p>
            </div>
            <div className="text-center">
              <h3 className="font-semibold mb-2">Instant Results</h3>
              <p className="text-gray-600">Get your detailed valuation report in minutes</p>
            </div>
          </div>
          
          {/* Demo Promo */}
          <div className="mt-16 bg-gray-50 rounded-xl p-8 text-center">
            <h3 className="text-xl font-bold mb-3">Not Ready to Commit?</h3>
            <p className="text-gray-600 mb-4">
              Try our interactive demo to see how the valuation process works before getting started.
              No sign-up required!
            </p>
            <button
              onClick={() => navigate('/valuation-demo')}
              className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-800"
            >
              <PlayCircle className="w-5 h-5 mr-2" /> View Interactive Demo
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}